<template>
    <div class="login" style="height:100%;display:flex;align-items:center;" v-if="islogin && teamList.length">
        <!-- v-if="islogin" -->
        <el-popover v-if="islogin" placement="top-end" :width="260" trigger="click">
            <template #reference>

                <div class="flex items-center justify-center gap-2">
                    <img class="w-[32px] h-[32px]"
                        :src="currentTeam.icon_url || 'https://file.aimano.xin/passport/system/dc1a6a7fb61647139a3d9f56c41726ff.png'"
                        alt="">
                    <div class="panel-title cursor-pointer" style="margin-right: 20px;">
                        <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                            <div style="max-width:250px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{
                                currentTeam.name }}
                            </div>
                            <el-icon>
                                <ArrowDownBold color="#8a8f99" />
                            </el-icon>
                        </div>
                        <div style="font-size:12px;color:#8a8f99;" v-if="currentTeam.employee_count">团队 {{
                            currentTeam.employee_count || 0 }}人</div>
                        <div style="font-size:12px;color:#8a8f99;" v-else>个人</div>
                    </div>
                </div>
            </template>
            <div class="content">
                <div class="item" v-for="item in teamList" :key="item.corp_code" @click="changeTeam(item)"
                    style="text-align:left;">
                    <div class="flex items-center justify-left gap-2">
                        <img class="w-[32px] h-[32px]" :src="item.icon_url" alt="">
                        <div>
                            <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                                <div style="max-width:250px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">
                                    {{
                                        item.name }}
                                </div>
                                <el-icon v-if="item.corp_code === currentTeam.corp_code"><Select
                                        color="#2a66ff" /></el-icon>
                            </div>
                            <div style="font-size:12px;color:#8a8f99;" v-if="item.employee_count">团队 {{
                                item.employee_count || 0 }}人
                            </div>
                            <div style="font-size:12px;color:#8a8f99;" v-else>个人</div>
                        </div>
                    </div>
                </div>
                <div style="border-bottom:1px solid #e5e5e5; margin: 10px 0;" v-if="currentTeam.corp_code"></div>
                <div class="item" @click="handleInvite" v-if="currentTeam.corp_code">邀请成员</div>
                <div class="item" @click="teamManager" v-if="currentTeam.corp_code">团队管理</div>
                <!-- <div style="padding: 10px;">
                    <el-button type="primary" style="width:100%;background-color:#2a66ff;"
                        @click="handleCreateTeam">创建团队/空间</el-button>
                </div>
                <div class="item" @click="handleLogout">退出登录</div> -->
            </div>
        </el-popover>
    </div>
</template>

<script lang="ts" setup>
import { ElButton, ElPopover, ElIcon, ElMessageBox } from 'element-plus'
import { User, ArrowDownBold, Select } from '@element-plus/icons-vue'
import { ref, computed, onMounted } from 'vue'
import { designTeam } from '@/api/affairs'
import { useMiscStore } from '@/stores/misc'

const handleClick = () => {

    ; (window as any).openGlobalLogin?.()
}
import { useUserStore } from '@/stores/user'
const userStore = useUserStore()
const islogin = computed(() => userStore.isLoggedIn)
const handleLogout = () => {
    // @ts-ignore
    Auth.request.requestor({
        url: "/open/jssdk/init/user/logout",
        method: "get",
    }).then(() => {
        userStore.clearAuth()
        window.location.href = '/editor'
    })
}
// 使用 Pinia 中的团队状态（不落地本地存储）
const currentTeam = ref({})
const teamList = ref([])
const getTeamList = async () => {

    currentTeam.value = userStore.currentTeamInfo || {}

    //@ts-ignore
    teamList.value = (userStore.teamList || []) as any[]

}

const changeTeam = async (item: any) => {
    if (item.corp_code == (currentTeam.value as any)?.corp_code || !item.corp_code) {
        return
    }
    const miscStore = useMiscStore()
    ElMessageBox.confirm(
        '切换身份后，已打开的页面权限将刷新。请确保设计内容已妥善保存。',
        '是否切换',
        {
            confirmButtonText: '切换',
            cancelButtonText: '取消',
            type: 'warning',
            // center: true
        }
    ).then(() => {
        //@ts-ignore
        Auth.request.requestor({
            url: "/open/jssdk/user/team/switch",
            method: "post",
            data: {
                client_id: miscStore.getClientID(),
                team_corp_id: item.corp_code,
            }
        }).then(() => {
            window.location.reload()
        })
    }).catch(() => {
        // 用户点击"取消"或关闭对话框，不做任何操作
        return
    })

}
const handleInvite = () => {
    //@ts-ignore
    Auth.header.showInvitePopup();

    // Auth.invitePopup.toggleShow()
}
const handleUpgrade = () => {
    window.open('https://passport.aimano.xin/', '_blank')
}
// desginsdk.designOpt.LeftTabChange('image')
const teamManager = () => {
    const miscStore = useMiscStore()
    window.open('https://passport.manocode.cn/team-info/' + miscStore.getClientID(), '_blank')

}
onMounted(() => {
    if (!userStore.isLoggedIn) {
        return
    }
    getTeamList()
})
</script>
<style scoped>
.login {
    position: relative;
}

.content {
    background-color: #fff;
    border-radius: 10px;
}

.item {
    padding: 10px;
    cursor: pointer;
    border-radius: 10px;
    text-align: center;
}

.item:hover {
    background-color: #f5f5f5;
}
</style>
